import { PlaceType } from '../../redux/actions/types'
import styles from './PublicPlaceItem.module.css'
import personCountIcon from '../../assets/icons/event-user.svg'
import noImage from '../../assets/img/no-image.jpg'
import CustomButton from '../UI/CustomButton/CustomButton'
import { useNavigate } from 'react-router-dom'

const PublicPlaceItem = ({
  place,
  setSelectedPlace,
}: {
  place: PlaceType
  setSelectedPlace: (place: PlaceType) => void
}) => {
  const navigate = useNavigate()

  return (
    <div className={styles.publicPlaceItem}>
      <div className={styles.publicPlaceItemImage}>
        {place.images.length >= 1 ? (
          <img
            src={`${process.env.REACT_APP_BASE_URL_IMAGES}${place.images[0]}`}
            alt={place.name}
          />
        ) : (
          <img className={styles.slideImage} src={noImage} alt='noImage' />
        )}
      </div>
      <div className={styles.publicPlaceItemContent}>
        <div className={styles.publicPlaceItemDescription}>
          <h3 className={styles.publicPlaceItemTitle}>{place.name}</h3>
          <div className={styles.personCountContainer}>
            <img className={styles.personCountIcon} src={personCountIcon} alt='personCountIcon' />
            <p className={styles.publicPlaceItemDescriptionHeaderText}>{place.size} человек</p>
          </div>
          <p className={styles.publicPlaceItemSubtitle}>{place.description}</p>
        </div>
        <div className={styles.buttonContainer}>
          <CustomButton
            className={styles.submitBtn}
            title={'Выбрать'}
            callbackHandler={() => {
              setSelectedPlace(place)
              navigate(`/public-place-card/${place.id}`)
            }}
          />
        </div>
      </div>
    </div>
  )
}

export default PublicPlaceItem
